module.exports = __webpack_public_path__ + "static/media/solo57.a7951088.JPG";